// BlogModal.jsx
import React from 'react';
import { Modal } from 'antd';
import { getImg } from "../../Api/getImg";

export default function BlogModal({ blog, isOpen, onClose }) {
    if (!blog) return null;

    // Function to detect if text contains Arabic characters
    const isArabic = (text) => {
        const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
        return arabicPattern.test(text);
    };

    // Check if title or summary contains Arabic
    const hasArabicContent = isArabic(blog.title) || isArabic(blog.summary);
    const textAlignment = hasArabicContent ? 'text-right' : 'text-left';
    const direction = hasArabicContent ? 'rtl' : 'ltr';
console.log('=====================dd===============');
console.log(hasArabicContent);
console.log('====================================');
    return (
        <Modal
            title={null}
            open={isOpen}
            onCancel={onClose}
            footer={null}
            width={800}
            centered
            destroyOnClose
            maskClosable={true} // This enables click outside to close
            className="blog-modal"
            styles={{
                body: {
                    padding: 0,
                },
            }}
        >
            <div className="relative">
                <img
                    src={getImg(blog.image)}
                    alt={blog.title}
                    className="w-full object-contain h-64 rounded-t-lg"
                    onError={(e) => (e.target.src = 'https://via.placeholder.com/400x300?text=Fallback+Image')}
                />
            </div>
            <hr></hr>
            
            <div className="p-6" dir={direction}>
                <h2 className={`text-2xl font-bold text-gray-900 mb-4 ${textAlignment}`}>
                    {blog.title}
                </h2>
                {blog.date && (
                    <p className={`text-gray-500 text-sm mb-4 ${textAlignment}`}>
                        {new Date(blog.date).toLocaleDateString()}
                    </p>
                )}
                <div className={`text-gray-700 leading-relaxed whitespace-pre-wrap ${textAlignment}`}>
                    {blog.summary}
                </div>
            </div>
        </Modal>
    );
}